module.exports = __webpack_public_path__ + "static/media/MountainRetreatEXTA0067_design_clean_v001.c8ef7196.png";